"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsButton = exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const Button_1 = require("../../components/Button/Button");
const { rem } = ui_common_components_1.utils;
const StyledRenderContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)} 0;
`;
function Tabs({ tabs, data, render, onUpdate }) {
    if (render && !tabs) {
        return ((0, jsx_runtime_1.jsx)(StyledRenderContainer, { children: render(onUpdate, data) }));
    }
    if (!render && tabs) {
        return (0, jsx_runtime_1.jsx)(ui_common_components_1.Tabs, { items: tabs });
    }
    return null;
}
exports.Tabs = Tabs;
function TabsButton({ icon, title, variant, onUpdate, customToggle, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: customToggle ? ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: "tooltip", onClick: onUpdate, children: customToggle })) : ((0, jsx_runtime_1.jsx)(Button_1.Button, { icon: icon, title: title, variant: variant, onClick: onUpdate })) }));
}
exports.TabsButton = TabsButton;
//# sourceMappingURL=Tabs.js.map